import { Module } from "wrapper6";
import $ from 'jquery';

export default class BenefitWidget extends Module {
    ready() {

        /*Target*/
        $('.benefit').click(function() {

            /*Before function*/
            $('.active').removeClass('active');

            /*Data*/
            let data = $(this).data('info');
            let fadeTime = 300;

            /*Templating*/
            let phraseTemplate = (phrase) => {
                return '<p>'+phrase+'</p>'
            };

            let operationalTemplate = (operation) => {
                return (
                    '<li>' +
                        '<p>'+operation.title+'</p>' +
                            '<div class="progressbar">' +
                                '<div class="progress" style="width: '+operation.percentage+'%"></div>' +
                            '</div>' +
                        '<p class="beats">'+operation.savingtext+' <span>'+operation.savingamount+'</span></p>' +
                    '</li>'
                )
            };

            let linkTemplate = (link) => {
                const linkClasses = 'mtt-arrow-link mtt-arrow-link--blue mtt-arrow-link--bold';
                return `<a href="${link.link}" class="${linkClasses}">${link.title}</a>`
            }

            /*Accessors*/
            const title = $('.benefits #title');
            const subtitle = $('.benefits #subtitle');
            const fade = $('.benefits #fadeOut');
            const phrases = $('.benefits #phrases');
            const operations = $('.benefits #operations');
            const text = $('.benefits #text');
            const savingsWrap = $('.benefits .savings');
            const linksWrap = $('.benefits .links');

            /*Function*/
            fade.css('opacity', 0);
            window.setTimeout(function (){
                title.html(data.title);
                text.html(data.text);
                linksWrap.html('');

                data.links.length ? linksWrap.removeClass('hidden') : linksWrap.addClass('hidden');
                data.text ? text.removeClass('hidden') : text.addClass('hidden');

                $(data.links).each(function(index, links){
                    linksWrap.append(linkTemplate(links));
                });

                fade.css('opacity', 1);
            }, fadeTime)

            /*After function*/
            $(this).addClass('active');

            $('html, body').animate({
                scrollTop: $('.benefits .right').offset().top - 100
            }, 'normal');

        });

    }
}